import { msg } from '@gonfalon/messages/msg';
import { ButtonBadge } from '@gonfalon/ui/Button';
import { Button, DialogTrigger, Popover } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import { AiConfigFiltersDialog } from './AiConfigFiltersDialog';
import { type AiConfigFilterSubset, countActiveProjectFilters, type FilterExcludeOptions } from './helpers';

import styles from './AiConfigFilters.module.css';

export function AiConfigFilters({
  filters,
  onChangeFilters,
  onClearFilters,
  filterExcludeOptions,
}: {
  filters: AiConfigFilterSubset;
  onChangeFilters: (filters: AiConfigFilterSubset) => void;
  onClearFilters: () => void;
  filterExcludeOptions?: FilterExcludeOptions;
}) {
  const activeFilterCount = countActiveProjectFilters(filters, filterExcludeOptions);

  return (
    <DialogTrigger>
      <Button variant="minimal">
        <Icon name="filter-list" size="small" slot="start-icon" /> {msg('aiConfigs.listFilters.trigger')}
        <Icon name="chevron-down" size="small" slot="end-icon" />
        {activeFilterCount > 0 ? (
          <ButtonBadge ariaLabel={msg('aiConfigs.listFilters.activeCountLabel', { count: activeFilterCount })}>
            {activeFilterCount}
          </ButtonBadge>
        ) : undefined}
      </Button>
      <Popover placement="bottom end" className={styles.popover}>
        <AiConfigFiltersDialog
          filters={filters}
          onClear={activeFilterCount > 0 ? onClearFilters : undefined}
          onChange={onChangeFilters}
        />
      </Popover>
    </DialogTrigger>
  );
}
